import { createStore } from 'redux'
import { useSelector, TypedUseSelectorHook } from 'react-redux'
import { MemberOption } from '../models/User.ts';

type state = {
  collaborations: Array<any>;
  allUsers: Array<MemberOption>;
  user: any;
}

const initialState: state = {
  collaborations:[],
  allUsers:[],
  user: null,
}

type args = { type?: string, [key: string]: any }

const changeState = (state = initialState, { type, ...rest }: args) => {
  switch (type) {
    case 'set':
      return {...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store

// https://react-redux.js.org/using-react-redux/static-typing#typing-the-useselector-hook
export const useTypedSelector: TypedUseSelectorHook<state> = useSelector
